// src/sanity/queries.ts

// Lightweight list for cards / listing pages
export const POSTS_QUERY_LIMITED = /* groq */ `
*[_type == "post"] | order(date desc){
  _id,
  title,
  "slug": slug.current,
  date,
  author->{ name },
  tags,
  coverImage{
    alt,
    asset->{ _id, url, metadata{ dimensions } }
  }
}
`;

// Full single-post query
export const POST_BY_SLUG = /* groq */ `
*[_type == "post" && slug.current == $slug][0]{
  _id,
  title,
  "slug": slug.current,
  date,
  tags,

  // author
  author->{ name },

  // hero image
  coverImage{
    alt,
    asset->{ _id, url, metadata{ dimensions } }
  },

  // optional H1 override
  h1Override,

  // Short teaser written for the blog cards. Also the meta-description
  // fallback when seoDescription/aiSummary are empty — see BlogPost.tsx.
  excerpt,

  // ───── SEO + TAB ─────
  // what shows in browser tab
  "tabTitle": coalesce(tabTitle, seoTitle, title),
  // what we put in <title> and og:title
  "seoTitle": coalesce(seoTitle, title),
  "seoDescription": coalesce(seoDescription, ""),
  canonical,
  "noIndex": noIndex == true,

  // Yoast-style keyword fields
  focusKeyword,
  metaKeywords,

  // Breadcrumb label (if missing, UI can fall back to title)
  breadcrumbLabel,

  // ───── LLM TRAINING FIELDS ─────
  aiSummary,
  aiSummaryLong,
  llmTags,
  llmDifficulty,
  llmEntities,
  llmQuestions,
  llmTakeaways,

  // ───── Hero Video ─────
  heroVideoUrl,

  // ───── Table of Contents ─────
  tableOfContents[]{
    title,
    anchor,
    subItems[]{ title, anchor }
  },

  // ───── SEO IMAGES ─────
  seoImage{
    alt,
    asset->{ _id, url, metadata{ dimensions } }
  },
  seoImages[]{
    alt,
    asset->{ _id, url, metadata{ dimensions } }
  },

  // ───── Page Content ─────
  "content": coalesce(content, body)[]{
    ...,
    // ensure PortableText images are fully resolved
    _type == "image" => {
      ...,
      alt,
      caption,
      "asset": asset->
    },
    // keep videoEmbed blocks with url + title
    _type == "videoEmbed" => {
      _type,
      url,
      title
    }
  }
}
`;

// About page singleton
export const ABOUT_PAGE_QUERY = /* groq */ `
*[_type == "aboutPage"][0]{
  heroImage{
    asset->{ _id, url, metadata{ dimensions } },
    hotspot
  }
}
`;

// Active team members, sorted by display order
export const TEAM_MEMBERS_QUERY = /* groq */ `
*[_type == "teamMember" && isActive == true] | order(order asc){
  _id,
  name,
  role,
  bio,
  linkedinUrl,
  photo{
    asset->{ _id, url, metadata{ dimensions } },
    hotspot
  }
}
`;

// Simple related-posts query
export const RELATED_POSTS = /* groq */ `
*[_type == "post" && slug.current != $slug] | order(date desc)[0...3]{
  _id,
  title,
  "slug": slug.current,
  date,
  tags,
  author->{ name },
  coverImage{
    alt,
    asset->{ _id, url, metadata{ dimensions } }
  }
}
`;

// AI Talent Drive companies shown in the candidate page's logo wall:
// display order first, then newest first
export const DRIVE_COMPANIES_QUERY = /* groq */ `
*[_type == "driveCompany" && isActive == true && defined(logo.asset)]
  | order(order asc, _createdAt desc){
  _id,
  name,
  note,
  website,
  logo{ asset->{ _id, url } }
}
`;
